<template>
  <div class="shadow bg-white p-4  mt-6 mb-10 rounded">
    <div v-if="!editMode">
      <vs-row vs-type="flex" vs-justify="space-between" class="pb-10" vs-w="12">
        <vs-button @click="editMode=true" color="primary" type="filled">Bearbeiten</vs-button>
      </vs-row>
    </div>
    <div v-else>
      <vs-row vs-type="flex" vs-justify="space-between" class="pb-10" vs-w="12">
        <vs-button @click="editMode=false" color="danger" type="filled">Abbrechen</vs-button>
        <vs-button @click="update()" color="success" type="filled" :disabled="disabled">{{saveText}}</vs-button>
      </vs-row>
    </div>
    <div v-if="infoType === 'agb'">
      <div v-if="!editMode" v-html="footer.agb" vs-w="12"/>
      <div v-else>
        <quill-editor style="width: 100%;" v-model="footer.agb"></quill-editor>
      </div>
    </div>
    <div v-else-if="infoType === 'imprint'">
      <div v-if="!editMode" v-html="footer.imprint" vs-w="12"/>
      <div v-else>
        <quill-editor style="width: 100%;" v-model="footer.imprint"></quill-editor>
      </div>
    </div>
    <div v-else-if="infoType === 'dataprotection'">
      <div v-if="!editMode" v-html="footer.dataprotection" vs-w="12"/>
      <div v-else>
        <quill-editor style="width: 100%;" v-model="footer.dataprotection"></quill-editor>
      </div>
    </div>
    <div v-else-if="infoType === 'payment'">
      <div v-if="!editMode" v-html="footer.payment" vs-w="12"/>
      <div v-else>
        <quill-editor style="width: 100%;" v-model="footer.payment"></quill-editor>
      </div>
    </div>
  </div>
</template>

<script>
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import {mapActions} from 'vuex'

  export default {
    props: {
      footerInfo: {
        type: Object
      },
      infoType: {
        type: String
      }
    },
    components: {
      quillEditor
    },
    data() {
      return {
        editMode: false,
        footer: {},
        saveText: 'Speichern',
        disabled: false,
      }
    },
    methods: {
      ...mapActions(['fetchFooterInfo']),
      ...mapActions(['updateFooterInfo']),
      update() {
        this.saveText = 'lädt...';
        this.disabled = true;
        this.updateFooterInfo(this.footer).then((res) => {
          this.editMode = false
          this.saveText = 'Speichern';
          this.disabled = false;
          if (res === true) {
            this.fetchFooterInfo().then(() => {
              this.$toast.success('Erfolgreich aktualisiert')
            })
          }
        })
      }
    },
    mounted() {
      this.footer = {...this.footerInfo}
    },
  }
</script>

<style scoped>

</style>
